module.exports = __webpack_public_path__ + "static/media/LifepodTeaserVideo.c4fa796d.mp4";